import React from 'react';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import { Modal } from 'react-bootstrap';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import { closeHeaderModal } from '../../actions/siteadmin/modalActions';

// Translation
import { FormattedMessage } from 'react-intl';
import messages from '../../locale/messages';

// Components
import LanguageModal from '../LanguageModal';
import s from './HeaderModal.css';

const HeaderModal = ({ modalType = 'languageModal' }) => {
  const dispatch = useDispatch();

  const modalStatus = useSelector(
    state => state.adminModalStatus[modalType]
  );

  const handleClose = () => {
    dispatch(closeHeaderModal(modalType));
  };

  return (
    <Modal
      show={modalStatus}
      animation={false}
      onHide={handleClose}
      dialogClassName='commonModalContainer languageModalPopup'
    >
      <Modal.Header closeButton className='commonModalHeader'>
        <Modal.Title >
          <div className="commonModalTitle">
            <FormattedMessage {...messages.chooseLanguageLabel} />
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='commonModalBody'>
        <LanguageModal />
      </Modal.Body>
    </Modal>
  );
};

export default withStyles(s)(HeaderModal);
